import React from 'react';
import styled from 'styled-components';
import theme from '../../../styles/theme';
import headingStyles from './headingStyles';

const { font, colors } = theme;

export const style = props => `
    font-family: ${font.recoletaMedium};
    color: ${colors.black};
    font-size: 44px;
    line-height: 56px;
    letter-spacing: 0.44px;
    margin-bottom: 8px;
`;

const HeroH1 = styled.h1(headingStyles, props => style(props));

export default ({ children, ...props }) => (
	<HeroH1 {...props}>{children}</HeroH1>
);
